/** @format */

import { discountFlag, doorIcon } from "../../assets/icons";
import { useModal } from "../../context/ModalContext";
import { useLanguageContext } from "../../context/LanguageContext";
import { formatDistance, driveLinkToImgTag } from "../../utils";
import { useMapContext } from "../../context/MapContext";
import { SERVICE_TYPE_CONFIG } from "../../constants";

export default function StoreItem({ marker }) {
  const { mapInstance } = useMapContext();
  const { showModal } = useModal();
  const { t } = useLanguageContext();

  function getServiceTypeConfig(type) {
    return SERVICE_TYPE_CONFIG[type] ?? null;
  }

  function handleClickItem() {
    showModal(marker);
    mapInstance.flyTo({
      curve: 1,
      zoom: 16,
      center: marker.coords,
    });
  }
  if ((marker.distance && marker.distance <= 0) || (marker.distance && marker.distance == NaN)) return;
  const logo = driveLinkToImgTag(marker.logo);
  return (
    <button
      onClick={handleClickItem}
      className="text-left w-full bg-gray-800 p-3 border-2 border-gray-700 mt-2 hover:border-main_accent_hover flex flex-row gap-2 rounded-lg items-center"
    >
      {logo}
      <div className="relative w-full">
        <div className="flex flex-row items-center gap-2">
          <h1 className="text-white font-medium text-clip">{marker.name}</h1>
        </div>
        <p className="text-sm font-medium inline flex flex-row gap-1 items-center">
          {marker.serviceType.map((type) => {
            const config = getServiceTypeConfig(type);
            if (!config) return null;

            return (
              <li key={type} className={`flex items-center gap-2 ${config.color}`}>
                {doorIcon}
              </li>
            );
          })}
          {marker.serviceType.length == 1 ? (
            <span className={` ${SERVICE_TYPE_CONFIG[marker.serviceType[0]].color}`}>
              {t("component", "marker", SERVICE_TYPE_CONFIG[marker.serviceType[0]].label)}
            </span>
          ) : (
            <span className="text-green-400">{t("component", "marker", "multiple")}</span>
          )}
        </p>
        <p className="text-sub_text_color text-sm">{t("component", "categories", marker.category)}</p>
        {marker.discount ? (
          <div className="absolute -right-4 top-6 flex">
            {discountFlag}
            {marker.discount ? (
              <span className="text-white absolute w-11 right-2 text-nowrap bg-[#BD4242] h-[23px] flex items-center justify-center text-center text-xs">
                {marker.discount != 1 ? marker.discount + "%" : "% OFF"}
              </span>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
        <p className="text-sub_text_color text-sm">{marker.distance ? formatDistance(marker.distance) : ""}</p>
      </div>
    </button>
  );
}
